import React, { useState, useRef } from "react";
import Educationcard from "./Education.card";
import "./education.css";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import WmModals from "../modals/Wm.Modals";
import { Row, Col } from "react-bootstrap";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import CircularProgress from "@material-ui/core/CircularProgress";
import Required from "../Components/required/Required"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dummy from "../assets/images/file.svg";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { addEducation, getUserDetail } from "../functions/details";
import ServerError from "../Pages/error/500/ServerError";
import Loading from "../Loading/Loading";
import { useMutation, useQuery, useQueryClient, } from "react-query";
const Cookie = new Cookies();
function Education() {
  const queryClient = useQueryClient()
  let history = useHistory();
  var token = Cookie.get("wmtoken");
  const backToLoginPage = () => { history.push("/login") };
  const [isEducationModal, setIsEducationModal] = useState(false);
  const [educationList, setEducationList] = useState();
  const [portfolioData, setPortfolioData] = useState({institute: '', course_title: '', board: '', start_date: '', end_date: '', grade: '', grade_privacyBool: true, grade_privacy: true, media_privacyBool: true, media_privacy: 0, mediaSend: '', media: dummy });
  const fileUpload = useRef(null);
  function handleImageClick() { fileUpload.current.click(); }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const reset = () => {
    setPortfolioData({ institute: '', course_title: '', board: '', start_date: '', end_date: '', grade: '', grade_privacyBool: true, grade_privacy: true, media_privacyBool: true, media_privacy: 0, mediaSend: '', media: dummy })
  }
  const { isError, isLoading, isSuccess, error } = useQuery(['educationData', 'EDUCATION'], getUserDetail, { refetchOnWindowFocus: false, onSuccess: data => { setEducationList(data[0]) } })
  const addTodoMutation = useMutation(data => addEducation(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('educationData')
      const previousValue = queryClient.getQueryData('educationData')
      return previousValue
    },
    onError: (previousValue) =>
      queryClient.setQueryData('educationData', previousValue),
    onSuccess: () => {
      queryClient.invalidateQueries('educationData')
      reset();
      setIsEducationModal(false)
    },
  })
  if (isLoading || addTodoMutation.isLoading) return <><div className="flex items-center justify-center"><Loading className={'w-48'} /></div></>;
  if (isError) return <><div><ServerError message={error.response.status} /></div></>
  if (isSuccess) return (
    <React.Fragment>
      {token ? (
        <React.Fragment>
          <div className="education container-fluid mb-10 md:mb-0">
            <div className="about_head">
              <span className="block manpro font-semibold text-3xl mb-3">Education</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {educationList?.map((educationData, idx) => { return (<Educationcard key={idx} educationData={educationData} />) })}
            </div>
            <div className="mt-10 text-center flex flex-col items-center">
              <Fab size="small" aria-label="add" className="bg-color-2 color-1 mb-2" onClick={() => setIsEducationModal(true)}><AddIcon /></Fab>
              <p className="cursor-pointer inline-block text-sm">Add New</p>
            </div>
          </div>
        </React.Fragment>
      ) : (
        backToLoginPage()
      )}
      <WmModals show={isEducationModal} onHide={() => setIsEducationModal(false)} size="lg" className="edu-modal">
        <h5 className="mb-4">Add Education Detail</h5>
        <form onSubmit={(e) => { e.preventDefault(); addTodoMutation.mutate(portfolioData) }}>
          <div className="wm_form_group flex flex-col mb-4">
            <label className="wm_form_label">Institute Name <Required /></label>
            <input placeholder="Institute Name" type="text" name="institute" required className="wm_form_input border-bottom border-gray-300" value={portfolioData.institute} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.institute = e.target.value; return { ...prevData } }) }} />
          </div>
          <div className="wm_form_group flex flex-col mb-4">
            <label className="wm_form_label">Course Name <Required /></label>
            <input placeholder="Course Name" type="text" name="course_title" required value={portfolioData.course_title} className="wm_form_input border-bottom border-gray-300" onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.course_title = e.target.value; return { ...prevData } }) }} />
          </div>
          <div className="wm_form_group flex flex-col mb-4">
            <label className="wm_form_label">Board/University <Required /></label>
            <input placeholder="Board/University" type="text" name="board" required value={portfolioData.board} className="wm_form_input border-bottom border-gray-300" onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.board = e.target.value; return { ...prevData } }) }} />
          </div>
          <Row>
            <Col md={6}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Start Date <Required /></label>
                <DatePicker selected={portfolioData.start_date} onChange={(date) => { setPortfolioData((prevData) => { prevData.start_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
              </div>
            </Col>
            <Col md={6}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">End Date <Required /></label>
                <DatePicker selected={portfolioData.end_date} onChange={(date) => { setPortfolioData((prevData) => { prevData.end_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
              </div>
            </Col>
            <Col md={7}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Grade/Percentage</label>
                <input placeholder="Grade/Percentage" type="text" name="grade" value={portfolioData.grade} className="wm_form_input border-bottom border-gray-300" onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.grade = e.target.value; return { ...prevData } }) }} />
              </div>
            </Col>
            <Col md={5}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Show Grade</label>
                <Wmswitch color="success" checked={portfolioData.grade_privacy} onChange={() => setPortfolioData((prevData) => { prevData.grade_privacy = !portfolioData.grade_privacy; return { ...prevData } })} />
              </div>
            </Col>
            <Col md={7}>
              <div className="wm_form_group flex mb-4 items-center">
                <div className="flex flex-col mr-4">
                  <label className="wm_form_label">Media</label>
                  <input type="file" name="grade" className="hidden" onChange={(e) => uploadImage(e)} ref={fileUpload} accept="image/png, image/jpeg, image/jpg" />
                  <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                    <img className="object-cover" src={portfolioData.media} alt="education" />
                  </div>
                </div>
                <Tooltip title={<React.Fragment>This media will be displayed in public profile And you can toggle to switch off the visibility</React.Fragment>} placement="right">
                  <HelpIcon />
                </Tooltip>
              </div>
            </Col>
            <Col md={5}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Show Media</label>
                <Wmswitch color="success" checked={portfolioData.media_privacy} onChange={() => setPortfolioData((prevData) => { prevData.media_privacy = !portfolioData.media_privacy; return { ...prevData } })} />
              </div>
            </Col>
          </Row>
          <div className="wm_form_group">
            <Wmbutton label={addTodoMutation.isLoading ? (<CircularProgress className="loader_size_xsm" />) : ("Save")} bordered className="rounded w-20 mr-2" type="submit" color="primary-border" />
            <Wmbutton label="Cancel" onClick={() => { setIsEducationModal(false); reset() }} className="rounded w-20" type="button" color="primary" />
          </div>
        </form>
      </WmModals>
    </React.Fragment>
  );
}
export default Education;